module.exports = __webpack_public_path__ + "img/greenPark.dbc64b98.svg";